import React, {ReactElement} from 'react';
import {ShippingType, StoreDetails} from '../../models/storeDetails';
import ShippingDetailsForm from './ShippingDetailsForm';
import ContactDetailsForm from './ContactDetailsForm';

type ContactDetailsProps = {
  storeSlug: string;
  storeDetails: StoreDetails;
};

const ContactDetails: React.FC<ContactDetailsProps> = ({
  storeSlug,
  storeDetails
}: ContactDetailsProps): ReactElement => {
  return (
    <>
      <ContactDetailsForm storeDetails={storeDetails} storeSlug={storeSlug} />
      {storeDetails.shippingType === ShippingType.HybridShipping && (
        <ShippingDetailsForm storeSlug={storeSlug} />
      )}
    </>
  );
};

export default ContactDetails;
